import { motion } from "framer-motion";

/**
 * BioLinkCard — animated link button with Framer Motion.
 * Hover/tap behaviour adapts per theme's motion.cardHover preset.
 *
 * Props: { theme, onClick, children, className, style, disabled }
 */

const HOVER = {
  press: { scale: 1, y: 0 },
  lift: { scale: 1.02, y: -3 },
  float: { scale: 1.01, y: -4 },
  glow: { scale: 1.015, y: -2 },
  neon: { scale: 1.025, y: -2 },
};

const TAP = {
  press: { scale: 0.96 },
  lift: { scale: 0.97, y: 0 },
  float: { scale: 0.97, y: 0 },
  glow: { scale: 0.97 },
  neon: { scale: 0.94 },
};

const SPRING = { type: "spring", stiffness: 400, damping: 25 };

export function BioLinkCard({ theme, onClick, children, className, style, disabled }) {
  const hoverPreset = theme?.motion?.cardHover || "press";

  return (
    <motion.button
      whileHover={disabled ? undefined : HOVER[hoverPreset]}
      whileTap={disabled ? undefined : TAP[hoverPreset]}
      transition={SPRING}
      onClick={onClick}
      disabled={disabled}
      className={[
        "w-full px-5 py-3.5 text-center text-sm font-semibold",
        "transition-colors duration-200",
        theme?.card || "",
        theme?.buttonShape || "",
        className || "",
      ].join(" ")}
      style={{ ...theme?.cardStyle, ...style }}
    >
      {children}
    </motion.button>
  );
}
